import { render, staticRenderFns } from "./customerDetails.vue?vue&type=template&id=1b29c40e&"
import script from "./customerDetails.vue?vue&type=script&lang=js&"
export * from "./customerDetails.vue?vue&type=script&lang=js&"
import style0 from "./customerDetails.vue?vue&type=style&index=0&id=1b29c40e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports